import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'
import TitledContent from 'components/TitledContent'
import Icon from 'components/Icon'
import CountUp from 'components/CountUp'
import NoData from 'components/NoData'
import messages from './messages'
import styles from './DashboardInsights.scss'

const SECTIONS = ['nonFiler', 'underReport']

const DashboardInsights = ({ counts = {} }) => (
  <div className={styles.container}>
    {SECTIONS.map(key => (
      <div key={key} className={cx(styles.section, styles[key])}>
        <Icon name={key} direcion='left' size='regular' className={styles.icon} />
        <TitledContent
          key={key}
          title={<FormattedMessage {...messages.titles[key]} />}
          titleClassName={styles.title}
          contentClassName={styles.count}
        >
          {counts[key] ? <CountUp to={counts[key]} /> : <NoData />}
        </TitledContent>
      </div>
    ))}
  </div>
)

DashboardInsights.propTypes = {
  counts: PropTypes.shape({
    nonFiler: PropTypes.number,
    underReport: PropTypes.number,
    nonRegister: PropTypes.number,
  }),
}

export default DashboardInsights
